export const constants = {
  server: 'https://us-central1-coaching-platform-illumine.cloudfunctions.net/serverResponse'
}